import React, { useEffect } from "react";
import { Flex, Spinner, Text } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignIn, useAuth } from "../ClerkAuthentication/clerkReact";
import { CLIENT_FLOW_DEFAULT_ROUTE, sanitizeClientReturnTo } from "./clientFlowUtils";
import { getConfigValue } from "../../config/runtimeConfig";
import { appendRedirectUrl } from "../ClerkAuthentication/clerkRedirects";

const ClientClerkLoginPage = () => {
  const { isSignedIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const fromState = location.state?.from;
  const fromPath = fromState
    ? `${fromState.pathname || ""}${fromState.search || ""}${fromState.hash || ""}`
    : "";
  const redirectTo = sanitizeClientReturnTo(fromPath || query.get("returnTo"), CLIENT_FLOW_DEFAULT_ROUTE);

  const signInUrl = getConfigValue(
    "REACT_APP_CLERK_SIGN_IN_URL",
    process.env.REACT_APP_CLERK_SIGN_IN_URL,
    "/login"
  );
  const isHostedSignIn = /^https?:\/\//i.test(signInUrl);

  useEffect(() => {
    if (!isSignedIn) return;
    navigate(redirectTo, { replace: true });
  }, [isSignedIn, navigate, redirectTo]);

  useEffect(() => {
    if (!isHostedSignIn) return;
    window.location.assign(appendRedirectUrl(signInUrl, redirectTo));
  }, [isHostedSignIn, signInUrl, redirectTo]);

  if (isHostedSignIn) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="gray.50" direction="column" gap={3}>
        <Spinner />
        <Text color="gray.600">Redirecting to client sign in...</Text>
      </Flex>
    );
  }

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <SignIn
        routing="path"
        path="/client/login"
        signUpUrl="/client/sign-up"
        forceRedirectUrl={redirectTo}
        fallbackRedirectUrl={redirectTo}
      />
    </Flex>
  );
};

export default ClientClerkLoginPage;
